module.exports = __webpack_public_path__ + "static/img/num.4ed78c56.png";